import classnames from 'classnames';
import React from 'react';
import styles from './action-button-label.scss';
import { isString } from 'lodash';
export const ActionButtonLabel = ({ className, label, shortLabel }) => (React.createElement("span", { "data-hook": "action-button-label", className: classnames(className, styles.container), ...(isString(label) && { 'data-label': label }), ...(shortLabel && { 'data-short-label': shortLabel }) }, React.isValidElement(label) && label));
//# sourceMappingURL=action-button-label.js.map